module.exports = __webpack_public_path__ + "img/logo_.60f5ed58.png";